export default __webpack_public_path__ + "static/media/e-order.8227f548.png";